import React from 'react'
import {
  DialogComponent
} from '../../shared/dialog/dialog.component'
import InputMask from 'react-input-mask'
import {
  loginApi
} from './login_api'

import { sharedData } from '../../../models/shared_data'

export class LoginEmailDialog extends React.Component {
  constructor(params) {
    super(params)
    this.state = {
      params: {
        email: '',
        password: ''
      },
      st: 'login',
      errors: {}
    }

    this.login = this.login.bind(this)
    this.toRecovery = this.toRecovery.bind(this)
    this.toLogin = this.toLogin.bind(this)
    this.doRecover = this.doRecover.bind(this)
  }

  toRecovery(e) {
    if(e)
      e.preventDefault()
      this.setState({
        st: 'recovery'
      })
  }

  toLogin(e) {
    if(e)
      e.preventDefault()

    this.setState({
      st: 'login'
    })
  }

  login(e) {
    if(e)
      e.preventDefault()
    if(!this.noErrors())
      return
    this.setState({
      errors: {}
    })
    const st = this.state.params
    loginApi.emailLogin(st.email, st.password)
      .subscribe((data)=> {
        if(data.status == 'ok') {
          sharedData.updateData(data.shared_data)
        } else {
          this.setState({
            errors: {
              phone: true,
              password: true
            }
          })
        }
      })
  }

  doRecover(e) {
    if(e)
      e.preventDefault()

    this.setState({
      errors: {}
    })
    const st = this.state.params
    loginApi.emailRecovery(st.email)
      .subscribe((data)=> {
        if(data.status == 'ok') {
          this.setState({
            st: 'recovered'
          })
        } else {
          this.setState({
            errors: {
              email: true
            }
          })
        }
      })
  }

  noErrors() {
    const st = this.state.params
    return (st.email.length > 0 && st.password.length > 3)
  }

  isError(name) {
    if(this.state.errors[name])
      return 'error'
    return ''
  }

  isValidPhone() {
    const phone = this.state.params.phone.replace(/\D/g,'');
    return phone.length >= 10 + ('' + sharedData.data.site_params.phone_start).length
  }

  changeParams(name, e) {
    e.preventDefault()

    const v = e.target.value
    this.setState((ps)=> {
      ps.params[name] = v
      return ps
    })
  }

  render() {
    const st = this.state
    // <div className="login-box__sub-link">
    //   <a href='' onClick={ (e)=> this.toState('login', e) }>Войти</a>
    //
    // </div>
    return (
      <div>
        { st.st == 'login' &&
        <DialogComponent height={290} opened={true} onClose={this.props.onClose}>
          <div className="login-box">
            <div className="h1">Войти</div>

            <form onSubmit={this.login}>
              <div className="input">
                <input
                  className={ "input__text " +
                    this.isError('password')
                  }
                  placeholder="email" type="email" value={st.params.email} onChange={(e)=> { this.changeParams('email', e) }}/>
              </div>
              <div className="input">
                <input
                  className={ "input__text " +
                    this.isError('password')
                  }
                  placeholder="Пароль" type="password" value={st.params.password} onChange={(e)=> { this.changeParams('password', e) }}/>
              </div>
              <button
                className={ "btn btn--red " +
                  (this.noErrors() ? '' : 'btn--disabled')
                }>
                Войти
              </button>
              &nbsp;
              <a href='' onClick={this.toRecovery}>Забыли пароль?</a>
            </form>
          </div>

        </DialogComponent>
      }
      { (st.st == 'recovery' || st.st == 'recovered' )  &&
        <DialogComponent height={250} opened={true} onClose={this.props.onClose}>
          <div className="login-box">
            <div className="h1">Восстановление пароля</div>
            {st.st == 'recovery' &&
              <form onSubmit={this.doRecover}>
                <div className="input">
                  <input
                    className={ "input__text " +
                      this.isError('email')
                    }
                    placeholder="email" type="email" value={st.params.email} onChange={(e)=> { this.changeParams('email', e) }}/>
                </div>
                <button
                  className={ "btn btn--red"
                  }>
                  Восстановить
                </button>
                &nbsp;
                <a href='' onClick={this.toLogin}>Войти</a>
              </form>
            }
            { st.st == 'recovered' &&
              <div>
                <div>
                  Новый пароль отправлен на вашу почту
                </div>
                &nbsp;
                <a href='' onClick={this.toLogin}>Войти</a>
              </div>
            }

          </div>

        </DialogComponent>
      }
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/login/login_email_dialog.component.jsx